// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3a4XV","content":"GlobalSearch_content__2G2SF"};